import store from "@/store"
import { defineStore } from "pinia"
import { removeToken, setToken, setExpiresIn, setRefreshToken, setLoginTime } from "@/utils/cookies"
import { resetRouter } from "@/router"
import { getPublicKey, accountLogin } from "@/api/login"
import { userInfoRequest } from "@/api/user"
import JSEncrypt from "jsencrypt"

interface IUserState {
  token: string
  roles: string[]
}

export const useUserStore = defineStore({
  id: "user",
  state: (): IUserState => {
    return {
      token: "",
      roles: []
    }
  },
  actions: {
    /** 设置角色数组 */
    setRoles(roles: string[]) {
      this.roles = roles
    },
    /** 登录 */
    login(userInfo: { username: string; password: string }) {
      return new Promise((resolve, reject) => {
        getPublicKey().then((response: any) => {
          const encrypt = new JSEncrypt()
          encrypt.setPublicKey(response)
          const password: any = encrypt.encrypt(userInfo.password)
          userInfo.password = password

          const submitForm = new FormData()
          submitForm.append("username", userInfo.username.trim())
          submitForm.append("password", userInfo.password)
          submitForm.append("grant_type", "password")
          submitForm.append(
            "scope",
            "openid offline_access phone profile role XMGISPlatform IdentityService BackendAdminAppGateway XMGisDict XMGISAuthenticate"
          )
          submitForm.append("client_id", "backend-admin-app-client")
          submitForm.append("client_secret", "1q2w3e*")
          accountLogin(submitForm)
            .then((res: any) => {
              setToken(res.access_token)
              setExpiresIn(res.expires_in)
              setLoginTime(new Date().getTime().toString())
              setRefreshToken(res.refresh_token)
              this.token = res.access_token
              resolve(true)
            })
            .catch((error) => {
              reject(error)
            })
        })
      })
    },
    /** 获取用户详情 */
    getInfo() {
      return new Promise((resolve, reject) => {
        userInfoRequest()
          .then((res: any) => {
            this.roles = []
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /** 登出 */
    logout() {
      removeToken()
      localStorage.clear()
      sessionStorage.clear()
      this.token = ""
      this.roles = []
      resetRouter()
    },
    /** 重置 token */
    resetToken() {
      removeToken()
      this.token = ""
      this.roles = []
    }
  }
})

/** 在 setup 外使用 */
export function useUserStoreHook() {
  return useUserStore(store)
}
